<template>
<FilterMe class="mb-2" @onSubmit="filters => filterMe(filters)" :filters="filters">
    <template #form="{filters}">
        <CRow>
            <CCol col="12" v-if="!storeId">
                <CInput v-model="filters.store.name" :placeholder="$t('conversion.store_name')" />
            </CCol>
            <CCol col="12" v-if="($policy('conversion').edit || $policy('conversion').view_any_or_group) && !userId">
                <CInput v-model="filters.user.full_name" :placeholder="$t('publisher.name')" />
            </CCol>
            <CCol col="12">
                <CInput v-model="filters.external_id" :placeholder="$t('conversion.external_id')" />
            </CCol>
            <CCol col="12">
                <CSelect2 v-model="filters.status" :options="conversionStatusOptionWithNull" />
            </CCol>
            <CCol col="12">
                <div role="group" class="form-group datepicker">
                    <datePicker :placeholder="$t('attributes.created_from')" :clearable="true" format="YYYY-MM-DD HH:mm:ss" display-format="dddd jDD jMMMM jYYYY" input-class="form-control" v-model="filters.min_created_at" type="datetime" />
                </div>
            </CCol>
            <CCol sm="12">
                <div role="group" class="form-group datepicker">
                    <datePicker
                        :placeholder="$t('attributes.created_to')"
                        :clearable="true"
                        format="YYYY-MM-DD HH:mm:ss"
                        display-format="dddd jDD jMMMM jYYYY"
                        input-class="form-control"
                        v-model="filters.max_created_at"
                        type="datetime"
                    />
                </div>
            </CCol>
        </CRow>
    </template>
</FilterMe>
</template>

<script>
import { mapActions } from 'vuex'
import { conversionStatusOptionWithNull } from '@/common/data'

export default {
    name: 'FilterIt',

    data() {
        return {
            conversionStatusOptionWithNull,
            filters: {
                external_id: '',
                min_created_at: '',
                max_created_at: '',
                status: '',
                store: {
                    name: ''
                },
                user: {
                    full_name: ''
                }
            },
        }
    },

    computed: {
        userId() {
            return this.$route.query.user_id || ''
        },
        storeId() {
            return this.$route.query.store_id || ''
        }
    },

    methods: {
        ...mapActions({
            fetch: 'conversion/fetch',
            setShowLoading: 'loadingComponent/setShowLoading',
        }),
        filterMe(filters) {
            this.setShowLoading(true)
            this.fetch({
                page: 1,
                ...filters,
            }).then(() => this.setShowLoading(false))
        },
    }
}
</script>